import { bootstrapApplication } from '@angular/platform-browser';
// import { registerLicense } from '@syncfusion/ej2-base';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://784ffaa3957efd149b44f370963805c9@o4509401738444800.ingest.us.sentry.io/4509401739689984",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});
// registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9RdkZjWntdcnxTQmBZ');
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
